import Component from './tiktok_applicant.vue'

export default Component
